function tooltipInit() {
    var elements = document.querySelectorAll('.js-tooltip');

    if(elements.length) {
        for(var i = 0; i < elements.length; i++) {
            var element = elements[i];

            element.addEventListener('click', function(event) {
                event.preventDefault();
                event.stopPropagation();

                tooltipClose();

                var tooltipContent = this.querySelector('.js-tooltip--content').cloneNode(true);
                tooltipContent.className = '';

                var tooltipFlyout = document.createElement('div');
                tooltipFlyout.classList.add('js-tooltip--flyout');
                tooltipFlyout.classList.add('tooltip--flyout');
                tooltipFlyout.classList.add('is-visible');

                var tooltipFlyoutClose = document.createElement('button');
                tooltipFlyoutClose.classList.add('js-tooltip--flyout--close');
                tooltipFlyoutClose.classList.add('tooltip--flyout--close');

                var tooltipFlyoutInner = document.createElement('div');
                tooltipFlyoutInner.classList.add('tooltip--flyout--inner');

                tooltipFlyoutInner.appendChild(tooltipContent);

                tooltipFlyout.appendChild(tooltipFlyoutClose);
                tooltipFlyout.appendChild(tooltipFlyoutInner);

                var elementPosition = this.getBoundingClientRect();

                tooltipFlyout.style.position = 'absolute';
                tooltipFlyout.style.top = Math.round(elementPosition.bottom + window.scrollY + 4) + 'px';
                tooltipFlyout.style.left = Math.round(elementPosition.left + window.scrollX - 4) + 'px';
                tooltipFlyout.style.margin = 0;

                document.body.appendChild(tooltipFlyout);

                tooltipFlyoutClose.addEventListener('click', function(event) {
                    tooltipClose();
                });

                document.addEventListener('click', function(event) {
                    if(!tooltipFlyout.contains(event.target)) {
                        tooltipClose();
                    }
                });
            });
        }
    }
}



function tooltipClose() {
    var activeTooltip = document.querySelector('.js-tooltip--flyout');
    if(activeTooltip) {
        activeTooltip.remove();
    }
}





document.addEventListener('DOMContentLoaded', function() {
    tooltipInit();
});

var target = document.body;
var config = { subtree: true, childList: true };

var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
        if(mutation.addedNodes.length) {

            // get added node
            var addedNode = mutation.addedNodes[0];

            // check if added node is element
            if(addedNode.nodeType === Node.ELEMENT_NODE) {

                // check if added node is carousel
                if(typeof addedNode.className === 'string' && addedNode.classList.contains('js-tooltip')) {
                    tooltipInit();
                }
                // or check if child of added node is carousel
                else {
                    var addedNodeChild = addedNode.querySelectorAll('.js-tooltip');
                    if(addedNodeChild.length) {
                        tooltipInit();
                    }
                }

            }
        }
    });
});

observer.observe(target, config);
